import {commitMutation, graphql} from 'react-relay';
import RelayService from '../service/RelayService';

const mutation = graphql`
    mutation DownloadCatalogMutation($input: DownloadCatalogInput!) {
        downloadCatalog(input: $input) {
            downloadedCatalog {
                status
                catalogId
                catalogName
                catalogPath
                companyId
                companyName
                companyPath

                recommendCatalogs {
                    catalog {
                      cluezCatalogId
                      cluezCompanyId
                      cluezCategoryIdPath
                      imageUrl1
                      previewImageUrl1
                      previewImageUrl2
                      previewImageUrl3
                      previewImageUrl4
                      videoUrl
                      documentGroupId
                      documentDisplayId
                      documentName
                      documentOriginalName
                      documentSubName
                      documentUrl
                      documentSizeBytes
                      documentDescription
                      documentPublishFlag
                      documentConversionFlag
                      documentExternalSiteFlag
                      companyContractId
                      companyContractDisplayId
                      companyNameLangValue
                      companyLogoUrlLangValue
                      catalogId
                      humanFileSize
                    }
                    brand {
                      brandId
                      urlId
                      nameLangValue
                      manufacturerBrandImageLangValue
                    }
                    document {
                      documentId
                      documentType
                      documentUrl
                      documentDisplayId
                      documentSubName
                      documentPublishFlag
                      documentConversionFlag
                      documentDescription
                      documentExternalSiteFlag
                      documentGroupId
                      documentName
                      documentOriginalName
                      documentSizeBytes
                      displayDocumentOriginalName
                      langKey
                      firstDocumentImageUrl
                      humanFileSize                        
                    }
                    label
                    langKey
                    humanFileSize
                    firstDocumentImageUrl
                    displayDocumentOriginalName
                    _score
                }
            }


        }

    }
`;

function DownloadCatalogMutation(environment, args) {
  console.log("DownloadCatalogMutation.js args", args, RelayService.clientMutationId);
  return new Promise((resolve, reject) => {
    return commitMutation(environment, {
      mutation,
      variables: {
        input: {
          ...args,
          clientMutationId: RelayService.clientMutationId,
        }
      },
      updater: store => {
      },
      onCompleted: (data, errors) => {
        if (errors) {
          return reject(errors);
        }
        console.log("DownloadCatalogMutation.js onCompleted : ", data); // undefined
        return resolve(data);
      },
      optimisticUpdater: store => {
      }
    });
  })
}

export default DownloadCatalogMutation;
